/** @file Thai catalog part of area E1 (W3-03), partial; replaced whole by that area. */

/** The `viewport` block (viewport notices, toolbar, overlay toggles); partial, English fills the gaps. S0 composes it into `th`. */
export const viewportTh = {
  canvas: 'วิวพอร์ตโครงกระดูก',
  toolbar: 'เครื่องมือวิวพอร์ต',
  modeSetup: 'ท่าตั้งต้น',
  modeAnimate: 'แอนิเมต',
  snap: 'สแนป',
  bones: 'กระดูก',
  names: 'ชื่อ',
  mesh: 'เมช',
  ik: 'IK',
  sockets: 'ซ็อกเก็ต',
  axes: 'แกน',
  grid: 'กริด',
  onion: 'ภาพซ้อนเฟรม',
  frameSelection: 'ซูมไปที่ที่เลือก',
  key: 'ใส่คีย์',
  suggestIk: 'แนะนำ IK',
  dismiss: 'ปิด',
  unkeyed: 'ท่าเปลี่ยนแต่ยังไม่ได้ใส่คีย์: กด ใส่คีย์ (K) หรือเปิด auto-key',
  noAnimation: 'เลือกแอนิเมชันในไทม์ไลน์ก่อนใส่คีย์',
  setupOnly: 'สลับเป็นโหมดท่าตั้งต้นเพื่อแก้ไขนี้',
  socketBone: 'กระดูกซ็อกเก็ตขยับตามซ็อกเก็ต: ลากจุดของซ็อกเก็ตด้วยเครื่องมือเลือก',
  noItem: 'กดบนไอเท็มที่ติดอยู่กับซ็อกเก็ต',
  noIk: 'ไม่มี IK ที่สิ้นสุดที่ {bone}',
  missingTexture: 'โหลดรูปไม่ได้ {count} รูป ส่วนนั้นจึงไม่แสดง',
  compileError: 'การแก้ไขล่าสุดคอมไพล์ไม่ผ่าน วิวพอร์ตจึงแสดงริกล่าสุดที่ใช้ได้',
  autorigHint: 'โปรเจกต์นี้มีรูป {n} รูปแต่ยังไม่มีสล็อต: ริกอัตโนมัติจะสร้างกระดูก สล็อต และ region จากรูปเหล่านี้ และให้ตรวจแผนก่อนนำไปใช้',
  autoRig: 'ริกอัตโนมัติทั้งตัว',
} as const;
